import { render, staticRenderFns } from "./dialog-showdetailupdatepackage.vue?vue&type=template&id=449f8b86&"
import script from "./dialog-showdetailupdatepackage.vue?vue&type=script&lang=js&"
export * from "./dialog-showdetailupdatepackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports